export { CookieManagementPage as default } from '@/components/enpages/CookieManagement'
